import {Component, OnInit} from '@angular/core';
import {DocumentModel} from '../../models/document.model';
import {LoadingController, ModalController} from '@ionic/angular';
import {NewDocumentService} from '../../services/new-document.service';
import {StateManagerService} from '../../services/state-manager.service';
import {CollectionsNames} from '../../definitions/collections-names';
import {TestConnectionService} from '../../services/test-connection.service';
import {RefreshdatabaseService} from '../../services/database/refreshdatabase.service';
import {GeneralService} from '../../services/general.service';
import {SiteModel} from '../../models/site.model';
import {DetaillineDTOModel} from '../../models/detaillineDTO.model';
import {ScanBarcodeCheckWardComponent} from '../healthcare/scan-barcode-check-ward/scan-barcode-check-ward.component';

@Component({
    selector: 'app-check-plant-item-service-history',
    templateUrl: './check-plant-item-service-history.component.html',
    styleUrls: ['./check-plant-item-service-history.component.scss'],
})
export class CheckPlantItemServiceHistoryComponent implements OnInit {

    documentTemp: DocumentModel;
    loading: any;

    constructor(public modalController: ModalController,
                private newDocumentService: NewDocumentService,
                private stateManagerService: StateManagerService,
                private collectionsNames: CollectionsNames,
                private testConnectionService: TestConnectionService,
                private refreshdatabaseService: RefreshdatabaseService,
                private generalService: GeneralService,
                private loadingController: LoadingController) {
    }

    async ngOnInit() {
        this.documentTemp = this.newDocumentService.genNewDocument();
        this.documentTemp.documentType = 7;
    }

    cancelCheck() {
        this.modalController.dismiss();
    }

    async scanItem() {
        const modal = await this.modalController.create({
            component: ScanBarcodeCheckWardComponent,
            backdropDismiss: false,
            cssClass: 'modal-fullscreen',
            componentProps: {
                document: this.documentTemp
            }
        });
        modal.onDidDismiss().then(() => {
        });
        return await modal.present();
    }


    async loadingSpinner() {
        await this.loadingController.create({
            message: 'Refreshing Live Detail Lines...',
            translucent: true,
            cssClass: 'custom-class custom-loading',
            spinner: 'bubbles'
        }).then((overlay) => {
            this.loading = overlay;
            this.loading.present();
        });
    }

}
